export default "__VITE_ASSET__BK$iccDQ__"